import React from "react";

const ReviewAverageStar: React.FC<{ rating?: number | string }> = ({
  rating,
}) => {
  const numRating =
    typeof rating === "string" ? parseFloat(rating) : rating || 0;
  // Convert rating (0-5) to percentage (0-100)
  const fillPercentage = Math.max(0, Math.min(100, (numRating / 5) * 100));

  return (
    <div className="relative w-[20px] h-[20px]">
      {/* Background (empty) star */}
      <svg
        className="absolute inset-0 w-full h-full text-ink-faint"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>

      {/* Foreground (filled) star */}
      <svg
        className="absolute inset-0 w-full h-full text-star"
        fill="currentColor"
        viewBox="0 0 20 20"
        style={{
          clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`,
        }}
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    </div>
  );
};

export default ReviewAverageStar;
